import { Component, Input } from '@angular/core';

import { SnShare } from '@lib/api/entities';
import { snFadeIn, snFadeOut, snListStagger } from '@lib/common/animations';
import { SnListBaseComponent } from '@lib/core';
import { t } from '@lib/translation';
import { SnActionConfig } from '@lib/ui/actions';

@Component({
  selector: 'fs-sharing-list-v2',
  templateUrl: './share-list-v2.component.html',
  styleUrls: ['./share-list-v2.component.scss'],
  animations: [snFadeIn, snFadeOut, snListStagger],
})
export class FsShareListV2Component extends SnListBaseComponent<SnShare> {
  @Input()
  public shareConfigAction: SnActionConfig;
  @Input()
  public shareDeleteAction: SnActionConfig;

  public trackBy(index: number, item: SnShare): string {
    return item.id;
  }

  public onEdit(item: SnShare, event: Event): void {
    event.stopPropagation();
    this.shareConfigAction.click(item);
  }

  public onDelete(item: SnShare, event: Event): void {
    event.stopPropagation();
    this.shareDeleteAction.click(item);
  }

  public getActivePermissions(item: SnShare): string[] {
    const permissions: string[] = [];
    const details = item.permissionsDetails;

    if (details.viewLiveVideo) {
      permissions.push(t('shares.permissionBadges.viewLive'));
    }
    if (details.viewPlayback) {
      permissions.push(t('shares.permissionBadges.viewRecordings'));
    }
    if (details.enablePtzControl) {
      permissions.push(t('shares.permissionBadges.controlPTZ'));
    }
    if (item.isRestricted) {
      permissions.push(t('shares.permissionBadges.conditionalShare'));
    }
    if (item.isAdminOnly) {
      permissions.push(t('shares.permissionBadges.adminOnly'));
    }
    return permissions;
  }

  public hasAccessDates(item: SnShare): boolean {
    return !!(item.startDate || item.endDate);
  }
}

